export enum AccountsRoutes {
  CreateOne = 'create-one',
  Search = 'search',
  UpdateOne = 'update-one',
}
